import React from 'react';
import './NotFound.css'
const NotFound = () => {
    return (
        <div className='text-center notFound text-primary'>
            <img  style={{width:'100wh'}} src={'https://i.ibb.co/M7z3Cj2/404-error-template-16.webp'} alt=""/>
        </div>
    );
};

export default NotFound;